<h1 mat-dialog-title>{{ title }} <span *ngIf="data.item.elementType && data.item.elementType == 'array'"> - Mappatura collegata: {{ data.item.structure }}</span></h1>

<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

  <div class="form-wrapper mt-1">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
      </formly-form>
    </form>
    <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions"
      class="btn-elevate">
    </mat-spinner-button>
  </div>

  <!-- Move document to another content (section), grouped by area -->
  <div class="mt-3" *ngIf="documents.length && destContentGroups.length">
    <div class="mb-1"><strong>{{ 'settings.document.move.title' | translate }}</strong></div>
    <form [formGroup]="moveDocForm" class="row">
      <mat-form-field class="col-12 col-md-6">
        <mat-label>{{ 'settings.document.move.sourceDocument' | translate }}</mat-label>
        <mat-select formControlName="docId" required>
          <mat-option *ngFor="let doc of documents" [value]="doc._id">
            {{ doc.translation.it }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-12 col-md-6">
        <mat-label>{{ 'settings.document.move.destContent' | translate }}</mat-label>
        <mat-select formControlName="dest" required>
          <mat-optgroup *ngFor="let group of destContentGroups" [label]="group.label">
            <mat-option *ngFor="let opt of group.contents" [value]="opt.value">
              {{ opt.label }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </form>
    <div class="text-right">
      <a mat-button (click)="onMoveDocumentSubmit()" mat-raised-button mat-default color="primary">
        {{ 'settings.document.move.save' | translate }}
      </a>
    </div>
  </div>

  <hr />
  <div class="row">
    <div 
      class="col-12 col-md-5 col-lg-4 drop-list mt-1"
      cdkDropList
      (cdkDropListDropped)="drop($event)">
      <div class="drop-box" *ngFor="let item of documents; let i = index;" cdkDrag>
        <button mat-stroked-button class="btn-block" (click)="onSubTitleClicked(item)">
          <div class="text-wrapper">
            {{ item.translation.it }}
          </div>
        </button>
      </div>
      <div class="row w-100 mt-4" *ngIf="documents.length === 0">
        Fai click sul pulsante "Aggiungi" per creare un nuovo elemento di "{{ title }}"
        <div class="col-6 text-left">
        </div> <!-- /.col -->
        <div class="col-6 text-right">
          <a mat-button (click)="onAddSubDocumentTemplate()" mat-raised-button mat-default color="primary">
            {{ 'common.cta.add' | translate }}
          </a>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
      <div class="row w-100 mt-4" *ngIf="documents.length > 0">
        <div class="col-6 text-left">
          <a mat-button (click)="onSaveSubDocumentTemplate()" mat-raised-button mat-default color="primary">
            {{ 'common.cta.save' | translate }}
          </a>
        </div> <!-- /.col -->
        <div class="col-6 text-right">
          <a mat-button (click)="onAddSubDocumentTemplate()" mat-raised-button mat-default color="primary">
            {{ 'common.cta.add' | translate }}
          </a>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </div>

    <div class="col-12 col-md-7 col-lg-8" *ngIf="subformIsVisible">
      <div class="mt-1"><strong>{{ subElementTitle }}</strong></div>
      <form [formGroup]="form">
        <formly-form [form]="subForm" [fields]="subFields" [model]="subModel" [options]="subOptions">
        </formly-form>
      </form>
      <mat-spinner-button (btnClick)="onSubFormSubmit(subModel)" role="submit" [options]="formBtnOptions"
        class="btn-elevate">
      </mat-spinner-button>
    </div>

    <div class="col-12 col-md-7 col-lg-8" *ngIf="newSubformIsVisible">
      <div class="mt-1"><strong>{{ 'settings.document.newThirdLevel' | translate }}</strong></div>
      <form [formGroup]="form">
        <formly-form [form]="newSubForm" [fields]="newSubFields" [model]="newSubModel" [options]="newSubOptions">
        </formly-form>
      </form>
      <mat-spinner-button (btnClick)="onNewSubFormSubmit(newSubModel)" role="submit" [options]="formBtnOptions"
        class="btn-elevate">
      </mat-spinner-button>
    </div>
  </div>
  
</mat-dialog-content>

<div mat-dialog-actions class="mt-5">
  <div class="row w-100">
    <div class="col-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default color="warn">
        {{ 'common.cta.close' | translate }}
      </a>
    </div> <!-- /.col -->
    <div class="col-6 text-right">
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>
